import { render, staticRenderFns } from "./shareImgPage.vue?vue&type=template&id=0fb29d08&scoped=true&"
import script from "./shareImgPage.vue?vue&type=script&lang=ts&"
export * from "./shareImgPage.vue?vue&type=script&lang=ts&"
import style0 from "./shareImgPage.vue?vue&type=style&index=0&id=0fb29d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb29d08",
  null
  
)

export default component.exports